import { Badge, Code, Table } from '@workos-inc/design-system';
export const WORKDAY_SCHEMA_ATTRIBUTES = {
  users: {
    required: [{
      name: 'employee_id',
      description: 'A unique ID representing the user'
    }, {
      name: 'first_name',
      description: 'The first name of the user'
    }, {
      name: 'last_name',
      description: 'The last name of the user'
    }, {
      name: 'primary_work_email',
      description: 'The primary work email for the user'
    }],
    optional: [{
      name: 'user_name',
      description: 'A unique human readable user name'
    }, {
      name: 'job_title',
      description: 'The job title of the user'
    }, {
      name: 'group_name',
      description: 'The name of the primary group the user belongs to'
    }, {
      name: 'employee_type',
      description: 'The type of employee'
    }, {
      name: 'employment_start_date',
      description: 'The date the user started working'
    }, {
      name: 'display_name',
      description: 'The display name of the user'
    }, {
      name: 'department_name',
      description: 'The name of the department the user belongs to'
    }, {
      name: 'manager_name',
      description: "The name of the user's manager"
    }, {
      name: 'manager_email',
      description: "The email of the user's manager"
    }, {
      name: 'manager_id',
      description: "The identifier of the user's manager from the directory provider"
    }, {
      name: 'division_name',
      description: 'The name of the division the user belongs to'
    }, {
      name: 'cost_center_name',
      description: 'The name of the cost center the user belongs to'
    }, {
      name: 'work_address_street',
      description: 'Work street address'
    }, {
      name: 'work_address_locality',
      description: 'Work city'
    }, {
      name: 'work_address_region',
      description: 'Work state'
    }, {
      name: 'work_address_postal_code',
      description: 'Work postal/zip code'
    }, {
      name: 'work_address_country',
      description: 'Work country'
    }]
  },
  groups: {
    required: [{
      name: 'group_name',
      description: 'The name of the group.'
    }]
  }
};
export const DirectorySyncWorkdaySchemaTableUsers = () => <Table.Root data-sentry-element="Table.Root" data-sentry-component="DirectorySyncWorkdaySchemaTableUsers" data-sentry-source-file="directory-sync-workday-schema-table.tsx">
    <Table.Content data-sentry-element="Table.Content" data-sentry-source-file="directory-sync-workday-schema-table.tsx">
      <Table.Header data-sentry-element="Table.Header" data-sentry-source-file="directory-sync-workday-schema-table.tsx">
        <Table.Row data-sentry-element="Table.Row" data-sentry-source-file="directory-sync-workday-schema-table.tsx">
          <Table.ColumnHeader width="33%" data-sentry-element="Table.ColumnHeader" data-sentry-source-file="directory-sync-workday-schema-table.tsx">CSV Header</Table.ColumnHeader>
          <Table.ColumnHeader data-sentry-element="Table.ColumnHeader" data-sentry-source-file="directory-sync-workday-schema-table.tsx">Status</Table.ColumnHeader>
          <Table.ColumnHeader data-sentry-element="Table.ColumnHeader" data-sentry-source-file="directory-sync-workday-schema-table.tsx">Description</Table.ColumnHeader>
        </Table.Row>
      </Table.Header>
      <Table.Body data-sentry-element="Table.Body" data-sentry-source-file="directory-sync-workday-schema-table.tsx">
        {WORKDAY_SCHEMA_ATTRIBUTES.users.required.map(attribute => <Table.Row key={attribute.name}>
            <Table.RowHeader>
              <Code variant="ghost">{attribute.name}</Code>
            </Table.RowHeader>
            <Table.Cell>
              <Badge color="blue">Required</Badge>
            </Table.Cell>
            <Table.Cell>{attribute.description}</Table.Cell>
          </Table.Row>)}
        {WORKDAY_SCHEMA_ATTRIBUTES.users.optional.map(attribute => <Table.Row key={attribute.name}>
            <Table.RowHeader>
              <Code variant="ghost">{attribute.name}</Code>
            </Table.RowHeader>
            <Table.Cell>
              <Badge color="gray">Optional</Badge>
            </Table.Cell>
            <Table.Cell>{attribute.description}</Table.Cell>
          </Table.Row>)}
      </Table.Body>
    </Table.Content>
  </Table.Root>;
export const DirectorySyncWorkdaySchemaTableGroups = () => <Table.Root data-sentry-element="Table.Root" data-sentry-component="DirectorySyncWorkdaySchemaTableGroups" data-sentry-source-file="directory-sync-workday-schema-table.tsx">
    <Table.Content data-sentry-element="Table.Content" data-sentry-source-file="directory-sync-workday-schema-table.tsx">
      <Table.Header data-sentry-element="Table.Header" data-sentry-source-file="directory-sync-workday-schema-table.tsx">
        <Table.Row data-sentry-element="Table.Row" data-sentry-source-file="directory-sync-workday-schema-table.tsx">
          <Table.ColumnHeader width="33%" data-sentry-element="Table.ColumnHeader" data-sentry-source-file="directory-sync-workday-schema-table.tsx">CSV Header</Table.ColumnHeader>
          <Table.ColumnHeader data-sentry-element="Table.ColumnHeader" data-sentry-source-file="directory-sync-workday-schema-table.tsx">Status</Table.ColumnHeader>
          <Table.ColumnHeader data-sentry-element="Table.ColumnHeader" data-sentry-source-file="directory-sync-workday-schema-table.tsx">Description</Table.ColumnHeader>
        </Table.Row>
      </Table.Header>
      <Table.Body data-sentry-element="Table.Body" data-sentry-source-file="directory-sync-workday-schema-table.tsx">
        {WORKDAY_SCHEMA_ATTRIBUTES.groups.required.map(attribute => <Table.Row key={attribute.name}>
            <Table.RowHeader>
              <Code variant="ghost">{attribute.name}</Code>
            </Table.RowHeader>
            <Table.Cell>
              <Badge color="blue">Required</Badge>
            </Table.Cell>
            <Table.Cell>{attribute.description}</Table.Cell>
          </Table.Row>)}
      </Table.Body>
    </Table.Content>
  </Table.Root>;
export const DirectorySyncWorkdaySchemaTable = {
  Users: DirectorySyncWorkdaySchemaTableUsers,
  Groups: DirectorySyncWorkdaySchemaTableGroups
};